import { hasAdminAccess } from './user';
import { isInSchoolAPEvents, isInSchoolEvent } from './event';

export function getRoutes(orgEvent, user) {
  let routes;

  if (hasAdminAccess(user.rid, user.role)) {
    if (isInSchoolEvent(orgEvent)) {
      routes = [
        'digitalHelp',
        'digitalCommon',
        'digitalHome',
        'digitalElevated',
        'digitalInSchoolRoomDetails',
        'downloads',
      ];
      if (isIrregularitySupported(orgEvent)) {
        routes.push('digitalIrregularities');
      }
    } else {
      routes = [
        'digitalHelp',
        'digitalCommon',
        'digitalHome',
        'digitalElevated',
        'weekendDigitalRoomDetails',
        'digitalIrregularities',
        'downloads',
      ];
    }
  } else {
    if (user?.room?.id) {
      if (isInSchoolEvent(orgEvent)) {
        routes = ['digitalHelp', 'digitalInSchool', 'digitalInSchoolHomeWithRoom', 'digitalInSchoolRoomDetails'];
        if (isIrregularitySupported(orgEvent)) {
          routes.push('digitalIrregularities');
        }
      } else {
        routes = [
          'digitalHelp',
          'digitalCommon',
          'DigitalHomeWithRoom',
          'weekendDigitalRoomDetails',
          'digitalIrregularities',
        ];
      }
    } else {
      if (isInSchoolEvent(orgEvent)) {
        routes = ['digitalHelp', 'digitalHome', 'digitalInSchool', 'digitalInSchoolRoomDetails'];
        if (isIrregularitySupported(orgEvent)) {
          routes.push('digitalIrregularities');
        }
      } else {
        routes = ['digitalHelp', 'digitalCommon', 'digitalHome', 'weekendDigitalRoomDetails', 'digitalIrregularities'];
      }
    }
  }

  return routes;
}

export function isIrregularitySupported(orgEvent) {
  return !isInSchoolAPEvents(orgEvent);
}
